const faqs = [
  {
    q: '51动漫官网是否需要注册才能在线观看动漫？',
    a: '不需要。51动漫官网支持免注册即点即看，所有动漫全集资源均可直接在线播放，无需登录即可享受流畅的追番体验。',
  },
  {
    q: '51动漫官网支持哪些设备进行在线观看？',
    a: '51动漫官网全面适配电脑、平板和手机端，无论您使用 Windows、Mac、iOS 还是 Android 设备，均可在浏览器中直接打开观看，无需安装额外插件。',
  },
  {
    q: '51动漫下载的动漫资源需要付费吗？',
    a: '完全免费。51动漫官网提供的所有动漫下载资源均为免费，涵盖日漫、国漫、韩漫等多种类型，您可随时下载喜爱的动漫全集离线观看。',
  },
  {
    q: '51动漫官网的下拉式追更模式如何使用？',
    a: '在播放或阅读页面中，向下滚动即可自动加载下一集或下一章节内容，无需手动点击翻页。51动漫官网的下拉式设计让追更体验更加流畅连贯。',
  },
  {
    q: '日漫、国漫和韩漫在51动漫官网的更新频率如何？',
    a: '51动漫官网每日同步更新最新番剧资源，日漫和国漫在播出后 24 小时内上线，热门韩漫每周定时更新，确保您第一时间追到最新内容。',
  },
  {
    q: '在51动漫官网遇到播放或下载问题怎么办？',
    a: '如遇播放卡顿，建议切换网络或刷新页面重试；下载问题可尝试更换浏览器。如问题持续，欢迎通过页面下方的联系方式向我们反馈，我们会尽快优化。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          常见问题
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-[960px] mx-auto">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-background-100/80 rounded-xl p-5 md:p-6 hover:bg-background-100 transition-colors duration-200"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}